/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AccountNav_user$ref = any;
type CartNav_user$ref = any;
type Notifications_user$ref = any;
type Rewards_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TopBar_user$ref: FragmentReference;
export type TopBar_user = {|
  +$fragmentRefs: AccountNav_user$ref & Rewards_user$ref & CartNav_user$ref & Notifications_user$ref,
  +$refType: TopBar_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TopBar_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AccountNav_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Rewards_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartNav_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7158036a09c9d13c7164a311163039cb';
module.exports = node;
